// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__7Qbq3","desc":"Heading_desc__XdDtr"};